import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import Dash3 from "../../assets/d-1.svg";
import Dash4 from "../../assets/d-2.svg";
import Savings from "../../assets/savings.svg";
import Dash5 from "../../assets/tc-1.svg";
import emailpic from "../../assets/email.svg";
import More from "../../assets/more.svg";
import More1 from "../../assets/m-1.svg";
import More2 from "../../assets/m-2.svg";
import More4 from "../../assets/m-4.svg";
import { Col, Row } from "react-bootstrap";
import add from "../../assets/add.svg";
import remove from "../../assets/remove.svg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { BusinessListing } from "../API/BusinessListingAPI/BusinessListing";
import { BusinessListingPlus } from "../API/BusinessListingAPI/BusinessListingPlus";
import Loader from "../Loader/Loader";
import { DeleteRowApi } from "../API/BusinessListingAPI/DeleteRow";
import { UpdateStatusApi } from "../API/BusinessListingAPI/UpdateStatus";
import Pagination from "../Pagination/Pagination";
import { saveAs } from "file-saver";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { SortAPi } from "../API/BusinessListingAPI/SortApi";
import swal from "sweetalert";
import Dropdown from "react-bootstrap/Dropdown";
import arrowDown from "../../assets/arrow-down.png";
import { MdClose } from "react-icons/md";
import { EmailViewApi } from "../API/BusinessListingAPI/EmailView";
import { BusinessPreviewAPi } from "../API/BusinessListingAPI/BusinessPreview";

import { SaveRequestAPI } from "../API/BusinessListingAPI/SaveRequest";
import NoDataText from "../NoDataText";
import { RequestPopupAPI } from "../API/BusinessListingAPI/RequestPopup";
import SearchBarResults from "../Search/SearchBarResults";
import { CategorySelectAPI } from "../API/BusinessListingAPI/CategorySelect";
import { MarketPlaceCategoryListAPI } from "../API/BusinessListingAPI/MarketPlaceCategoryList";
import { Switch } from "antd";
import { UpdateFeatureStatusApi } from "../API/BusinessListingAPI/UpdateFeatureStatus";
import { UpdateFeatureListApi } from "../API/BusinessListingAPI/UpdateFeatureList";
import { getFeaturedListingApi } from "../API/BusinessListingAPI/getFeaturedListing";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";
import { CustomerListingApi } from "../API/CustomerListingAPI/CustomerListing";
import { ExportCustomerListing } from "../API/BusinessListingAPI/ExportCustomerListing";

const CustomerListings = () => {
  let navigate = useNavigate();
  const cityId = localStorage.getItem("cityId");

  const [loading, setLoading] = useState(false);
  const [TableRows, setTableRows] = useState([]);
  const [globalTableRows, setglobalTableRows] = useState([]);

  const [title, setTitle] = useState("");
  const [selctedRow, setselctedRow] = useState(null);
  const [expandedRows, setExpandedRows] = useState("");
  const [expandedRowsData, setExpandedRowsData] = useState({});
  const [listingNo, setlistingNo] = useState(5);
  //
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [ShowTable, setShowTable] = useState(false);
  const [Nodata, setNodata] = useState(false);



  // search
  const [searchValue, setsearchValue] = useState("");
  // pagination
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [limit, setLimit] = useState(0);
  const [colValue, setColValue] = useState("");
  const [sortNo, setSortNo] = useState(0);
  // sort
  const [flag, setFlag] = useState({
    customer_name: 0,
    eu_email: 0,
    eu_contact_number: 0,
    transaction_date: 0,
    product_type: 0,
  });

  const path = window.location.href;
  const endPath = path.split("/");

  useEffect(() => {
    setLoading(true);
    const url = endPath[3].replace(/-/g, " ");
    const arr = url.split(" ");
    for (var i = 0; i < arr?.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const url_final = arr.join(" ");
    setTitle(url_final);
    handleCustomerListing()
  }, [path,]);


  useEffect(() => {
    handleCustomerListing()
  }, [pageNumber, colValue, sortNo, cityId, limit])


  const handleCustomerListing = async () => {
    let payload = {
      limit: limit,
      offset: pageNumber,
      search_value: searchValue,
      column_name: colValue,
      sort_type: sortNo,
      export: false,
      mms_city_id: parseInt(cityId),
    }
    const responseData = await CustomerListingApi(payload, () => {
      navigate("/");
    });
    if (responseData === false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (responseData.status === 429) {
        setLoading(true);
        setShowTable(false);
        swal({
          // title: "Error!",
          title: responseData.message,
          icon: "error",
          // buttons: "Ok",
          dangerMode: true,
        });
      } else if (responseData.status === 200) {
        setShowTable(false);
        setTableRows(responseData.data)
        setTotalPageCount(responseData?.total_rows);
        setLimit(responseData.limit);
      } else if (responseData?.message === "No Data Available") {
        setShowTable(true);
      } else {
        setShowTable(true);
        setTableRows([])
        setTotalPageCount(0)
        setLimit(0)
      }
    }

    setLoading(false);
  }
  // export
  const handleExport = async (e) => {
    setLoading(true);

    const data = {
      mms_city_id: parseInt(cityId),
      // listing_for: listingNo,
      export: true,
    };
    const responseData = await ExportCustomerListing(data, () => {
      navigate("/");
    });
    console.log("responseData", responseData)
    let blob = new Blob([responseData], {
      type: "application/vnd.ms-excel",
    });
    console.log("blob", blob)
    saveAs(blob, `${title}.xlsx`);
    setLoading(false);
  };


  // function to sort-button
  const HandleSortCol = (value) => {
    // customer_name: 0,
    if (value == "customer_name") {
      if (flag.customer_name === 0) {
        setColValue(value)
        setSortNo(1)
        setFlag((item) => {
          return { ...item, customer_name: 1 };
        });
      } else if (flag.customer_name === 1) {
        setColValue(value)
        setSortNo(2)
        setFlag((item) => {
          return { ...item, customer_name: 2 };
        });
      } else {
        setColValue(value)
        setSortNo(0)
        setFlag((item) => {
          return { ...item, customer_name: 0 };
        });
      }
    }
    if (value == "eu_contact_number") {
      if (flag.eu_contact_number === 0) {
        setColValue(value)
        setSortNo(1)
        setFlag((item) => {
          return { ...item, eu_contact_number: 1 };
        });
      } else if (flag.eu_contact_number === 1) {
        setColValue(value)
        setSortNo(2)
        setFlag((item) => {
          return { ...item, eu_contact_number: 2 };
        });
      } else {
        setColValue(value)
        setSortNo(0)
        setFlag((item) => {
          return { ...item, eu_contact_number: 0 };
        });
      }
    }
    if (value == "eu_email") {
      if (flag.eu_email === 0) {
        setColValue(value)
        setSortNo(1)
        setFlag((item) => {
          return { ...item, eu_email: 1 };
        });
      } else if (flag.eu_email === 1) {
        setColValue(value)
        setSortNo(2)
        setFlag((item) => {
          return { ...item, eu_email: 2 };
        });
      } else {
        setColValue(value)
        setSortNo(0)
        setFlag((item) => {
          return { ...item, eu_email: 0 };
        });
      }
    }
    if (value == "product_type") {
      if (flag.product_type === 0) {
        setColValue(value)
        setSortNo(1)
        setFlag((item) => {
          return { ...item, product_type: 1 };
        });
      } else if (flag.product_type === 1) {
        setColValue(value)
        setSortNo(2)
        setFlag((item) => {
          return { ...item, product_type: 2 };
        });
      } else {
        setColValue(value)
        setSortNo(0)
        setFlag((item) => {
          return { ...item, product_type: 0 };
        });
      }
    }

    if (value == "transaction_date") {
      if (flag.transaction_date === 0) {
        setColValue(value)
        setSortNo(1)
        setFlag((item) => {
          return { ...item, transaction_date: 1 };
        });
      } else if (flag.transaction_date === 1) {
        setColValue(value)
        setSortNo(2)
        setFlag((item) => {
          return { ...item, transaction_date: 2 };
        });
      } else {
        setColValue(value)
        setSortNo(0)
        setFlag((item) => {
          return { ...item, transaction_date: 0 };
        });
      }
    }
  };
  const handleSearchInput = (e) => {
    if (e.target.value === '') {
      handleCustomerListing();
    }
    setsearchValue(e.target.value)
  }
  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleCustomerListing()
    }
  };



  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>

        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Customer List</p>
          <div className="acc-dashboard mt-4 BListings-tabs">
            {/* <TabsSection /> */}
            <div
              className={
                endPath[3] !== "customer-listings"
                  ? "pt-3 pb-3 Blist"
                  : "manage-feature pt-3 pb-3 Blist"
              }
            >
              {/* <div style={{ width: "50%" }}>
                <p className="page-maintitle pt-2">{title}</p>
                {endPath[3] === "customer-list" ? (
                  <p className="page-subtitle">
                    Drag and drop the listings to rearrange them in your desired
                    order, then click Save to apply any changes.
                  </p>
                ) : (
                  <p className="page-subtitle">
                    Any business with published status will be visible in the
                    marketplace
                  </p>
                )}
              </div> */}


              <div className="manage-vou-custom">
                <InputGroup className="search-bar">
                  <InputGroup.Text>
                    <MdSearch />
                  </InputGroup.Text>
                  <Form.Control
                    className="search_feild"
                    value={searchValue}
                    onChange={(e) => handleSearchInput(e)}
                    onKeyPress={handleKeypress}
                  />
                  <Button variant="outline-secondary" onClick={handleCustomerListing}>
                    Search
                  </Button>
                </InputGroup>
                <div
                  variant="primary"
                  className="create-btn export-btn-main1"
                  onClick={handleExport}
                >
                  Export <MdOutlineLogout className="export-btn" />
                </div>
              </div>

            </div>
            {searchValue && <SearchBarResults SearchValue={searchValue} />}


            <>
              {/* <span>Number of Business Listing : {TableRows.length}</span> */}
              <div className="table-responsive-xl black-header">
                <table className="recentact-table mt-3 table ver-middle manage-vou-table bus-list-Table">
                  <thead>
                    <tr>
                      <th className="radio-colors">

                      </th>
                      <th
                        onClick={() => HandleSortCol("customer_name")}
                        width="300px"
                      >
                        <Button className="btn btn-primary sortIcon">
                          Customer Name
                          {flag.customer_name === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.customer_name === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      <th onClick={() => HandleSortCol("eu_contact_number")}>
                        <Button className="btn btn-primary sortIcon">
                          Mobile Number{" "}
                          {flag.eu_contact_number === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.eu_contact_number === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      <th onClick={() => HandleSortCol("eu_email")}>
                        <Button
                          className="btn btn-primary sortIcon"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >Email Address{flag.eu_email === 0 ? (
                          <FaSort></FaSort>
                        ) : flag.eu_email === 1 ? (
                          <FaSortUp></FaSortUp>
                        ) : (
                          <FaSortDown></FaSortDown>
                        )}
                        </Button>
                      </th>
                      <th onClick={() => HandleSortCol("transaction_date")}>
                        <Button
                          className="btn btn-primary sortIcon"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >Date of Transaction
                          {flag.transaction_date === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.transaction_date === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                      <th onClick={() => HandleSortCol("product_type")}>
                        <Button
                          className="btn btn-primary sortIcon"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          Voucher/Coupon
                          {flag.product_type === 0 ? (
                            <FaSort></FaSort>
                          ) : flag.product_type === 1 ? (
                            <FaSortUp></FaSortUp>
                          ) : (
                            <FaSortDown></FaSortDown>
                          )}
                        </Button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ShowTable === false ? (
                      <>
                        {TableRows?.length > 0 ? (
                          TableRows?.map((item, key) => {
                            return (
                              <>
                                <tr>
                                  <td></td>
                                  <td >
                                    {item?.customer_name}
                                  </td>
                                  <td >
                                    {item?.mobile_number}
                                  </td>
                                  <td>{item?.eu_email}</td>

                                  <td>{FormatDateShortMonth(item?.transaction_date)}</td>
                                  <td>{item?.product_type}</td>
                                </tr>
                              </>
                            );
                          })
                        ) : (
                          <tr className="toggle-row">
                            <td colSpan={9}>
                              <p className="noData">{NoDataText.ErrText}</p>{" "}
                            </td>
                          </tr>
                        )}
                      </>
                    ) : (
                      <tr className="toggle-row">
                        <td colSpan={9}>
                          <p className="noData">{NoDataText.ErrText}</p>{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {totalPageCount > 10 ? (
                <Pagination
                  totalPageCount={totalPageCount}
                  setPageNumber={setPageNumber}
                  limit={limit}
                />
              ) : (
                <>
                </>
              )}
            </>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default CustomerListings;
